import { EventResponseDto } from '@diritto/common/event/dtos/event.dto';
import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { EventButton } from 'app-components/events/detail/EventButton';
import { EventHeader } from 'app-components/events/detail/EventHeader';
import { EventShare } from 'app-components/events/detail/EventShare';
import React from 'react';
import { IkImage } from 'ui-components/Imagekit/IkImage';

interface EventViewProps {
  eventData: EventResponseDto;
}

export const EventNormalView = ({ eventData }: EventViewProps) => {
  const { event, eventFiles } = eventData;
  const { title, subDescription } = event;
  const { extraInfo } = event;
  const isFullPage = extraInfo?.payload?.isFullPage;

  return (
    <>
      <StyledEventHeader event={event} />
      <StyledContainerWrapper>
        <StyledImageWrapper isFullPage={isFullPage}>
          {eventFiles.map(eventFile => (
            <IkImage
              key={eventFile.id}
              transform={{
                path: eventFile.path,
                isPrivate: eventFile.isPrivate,
              }}
              alt={`event-${eventFile.id}`}
            />
          ))}
        </StyledImageWrapper>
        <EventButton event={event} />
        <StylesDescriptionWrapper>
          {subDescription && <StylesSubDescription>{subDescription}</StylesSubDescription>}
          <StyledDivider />
          <EventShare eventTitle={title} />
        </StylesDescriptionWrapper>
      </StyledContainerWrapper>
    </>
  );
};

const StyledEventHeader = styled(EventHeader)`
  padding-top: 24px;
  margin-bottom: 24px;
`;

const StyledContainerWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;

  text-align: center;
  margin-bottom: 24px;
`;

const StylesDescriptionWrapper = styled.section`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledImageWrapper = styled.div<{ isFullPage?: boolean }>`
  max-width: ${({ isFullPage }) => (isFullPage ? '100%' : '320px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StylesSubDescription = styled.div`
  ${Typography.XXSmall}
  color: ${Color.Gray600};
  margin-top: 16px;
  white-space: break-spaces;
`;

const StyledDivider = styled.div`
  margin: 48px auto;
  width: 120px;
  height: 1px;
  background-color: ${Color.Gray300};
  display: inline-block;
`;
